let signupForms = () => {
  let $registerForm = $('#form-register');
  let $registerButton = $registerForm.find('.btn');

  $registerForm.on('change', '[type="radio"]', function (event) {
    let $checked = $registerForm.find('[type="radio"]:checked');

    $registerButton.attr('href', $checked.data('button-link'));
    $registerButton.find('span').html($checked.data('button-text'));
  });
};

function checkRecaptcha() {
  if (document.querySelectorAll('form button[type=submit]').length) {
    document.querySelectorAll('form button[type=submit]')[0].disabled = false;
  }
}
window.checkRecaptcha = checkRecaptcha;

let ajaxForms = () => {
  $('body').on('submit', 'form[data-ajax-form]', function (event) {
    event.preventDefault();

    let $form = $(this);
    let $button = $(document.activeElement);
    $button.prop('disabled', true);

    $.post(
      $form.attr('action'),
      $form.serialize()
    ).always(function () {
      $form.find('.form-message').removeClass('error success');
      $form.find('.erroneous').removeClass('erroneous');
    }).done(function (response) {
      //$button.prop('disabled', false);
      let $message = $form.find('.form-message');

      if ($form.attr('data-redirect')) {
        window.location = $form.data('redirect');
      } else {
        $message.addClass('success');

        // Is this part of a modal?
        if ($form.closest('.modal').length) {
          window.setTimeout(function () {
            $form.closest('.modal').modal('hide');
          }, 5000);
        }

        $form.find('[type="submit"]').prop('disabled', 'disabled');
        $form.find('input, textarea, select').prop('value', '');
      }
    }).fail(function (xhr, status, error) {
      $button.prop('disabled', false);
      let $message = $form.find('.form-message');
      $message.addClass('error');
      let errors = [];

      for (let key in xhr.responseJSON) {
        if (!xhr.responseJSON.hasOwnProperty(key)) {
          continue;
        }
        $form.find('[name="' + key + '"]').addClass('erroneous').focus();
        errors.push(xhr.responseJSON[key].map((v) => v.value !== undefined ? v.value : v).join(' '));
      }
      $message.find('.form-message-text-error').html(errors.join('<br>'));
    });
  });
};

export default function () {
  signupForms();
  ajaxForms();
}
